import { Box, Divider, styled } from '@mui/material';
import { cn } from '@tempo-io/sui-class-utils';
import type { ComponentProps } from 'react';

export const StyledDiv = styled('div')({
  position: 'absolute',
  marginTop: '15%',
  marginLeft: '35%',
});

export const StyledBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '11px',
  padding: '2rem',
  textAlign: 'center',
});

export function TitleTypography({ className, ...props }: ComponentProps<'p'>) {
  return (
    <p
      className={cn('text-[20px] font-medium leading-8 tracking-[0.15px]', className)}
      {...props}
    />
  );
}

export function SubtitleTypography({ className, ...props }: ComponentProps<'p'>) {
  return (
    <p
      className={cn('text-[16px] font-normal leading-6 tracking-[0.15px]', className)}
      {...props}
    />
  );
}

export function FooterTypography({ className, ...props }: ComponentProps<'p'>) {
  return (
    <p
      className={cn(
        'text-sm leading-[19.6px] text-text-neutral-secondary pt-8 [&_a]:font-bold [&_a]:text-text-link',
        className,
      )}
      {...props}
    />
  );
}

export const StyledDivider = styled(Divider)({
  width: '95%',
  marginTop: '1.6rem',
});
